import 'react';
import { jsx } from 'react/jsx-runtime';

const StopIcon = ({
  size,
  color = "currentColor",
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10",
    style: {
      ...svgProps.style,
      width: `${size.toString()}px`,
      height: `${size.toString()}px`
    },
    fill: color,
    children: /*#__PURE__*/jsx("rect", {
      width: "10",
      height: "10",
      rx: "1.5"
    })
  });
};

export { StopIcon };
//# sourceMappingURL=StopIcon.js.map
